export const shadows = {
  1: '3px 3px 6px #0000000a',
  2: '0 3px 6px #00000029',
  3: '3px 3px 6px #00000029',
};
